// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__7quJp","errorLogs":"styles_errorLogs__1cCBp"};